// extracted by mini-css-extract-plugin
module.exports = {"linksWrapper":"styles_linksWrapper__15hKU","link":"styles_link__18bWX","vert":"styles_vert__1Pa7w"};